import { MagnifyingGlassIcon } from '@heroicons/react/24/outline'
import PropTypes from 'prop-types'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ActivityIndicator from 'react-spinners/BeatLoader'

import { useLanguageContext } from '../../../context'
import { query } from '../../../graphql'

const SelectPreset = ({ callback }) => {
  const { t } = useTranslation()
  const { language } = useLanguageContext()

  // const presetsRef = useRef([])

  const [input, setInput] = useState('')
  const [hardcodedInput, setHardcodedInput] = useState(null)

  const [isLoading, setIsLoading] = useState(false)
  const [presets, setPresets] = useState([])

  useEffect(() => {
    if (!input || input.length < 3) {
      setPresets([])
      setIsLoading(false)
      return
    }

    setIsLoading(true)

    const timeout = setTimeout(() => {
      query({
        query: 'publicSqlQuery',
        variables: {
          action: 'query-career-syns-by-name',
          input: JSON.stringify({ career_name: input })
        }
      }).then((response) => {
        const items = JSON.parse(response.Items).map((item) => {
          item.name = JSON.parse(item.name)
          item.displayValue = item.name[language]
          item.syns = JSON.parse(item.syns)

          const synonyms = item.syns[language]
          Object.keys(item.syns).forEach((languageKey) => {
            if (languageKey === language) return

            synonyms.push(...item.syns[languageKey])
          })

          // finds the first entry - dashboard language has a higher prio
          item.synonym = synonyms.find((synonym) =>
            synonym.toLowerCase().includes(input.toLowerCase())
          )

          return item
        })

        items.length = 5

        setPresets(items)
        setIsLoading(false)
      })
    }, 1000 * 0.8)

    return () => clearTimeout(timeout)
  }, [input, language])

  return (
    <div className='relative'>
      <div className='relative mt-1 border-b border-gray-300 focus-within:border-blue-600'>
        <MagnifyingGlassIcon
          className='absolute left-2 top-2 h-5 w-5 text-blue-600'
          aria-hidden='true'
        />
        <input
          id='search-input-backend'
          name='search-input-backend'
          type='text'
          autoComplete='off'
          className='block w-full border-0 border-b border-transparent bg-white pl-10 text-sm placeholder-shown:italic focus:border-blue-600 focus:ring-0'
          placeholder={t(
            'career.requirement_profile.presets.search_input_placeholder'
          )}
          value={hardcodedInput || input}
          onChange={(event) => {
            setHardcodedInput(null)
            setInput(event.target.value)
          }}
          // onBlur={() => {
          //   presetsRef.current = presets
          //   setPresets([])
          // }}
          // onFocus={() => {
          //   setPresets(presetsRef.current)
          //   presetsRef.current = []
          // }}
        />
        <ul className='absolute z-10 mt-1 w-full divide-y divide-gray-200 rounded-lg bg-white px-6 pb-2 shadow-xl'>
          {presets.map((item, index) => (
            <li key={index}>
              <button
                onClick={() => {
                  callback(item)
                  setPresets([])
                  setHardcodedInput(item.displayValue)
                  setInput('')
                }}
                className='w-full p-2 text-left hover:cursor-pointer hover:bg-gray-50'
              >
                <span className='text-sm font-medium text-gray-900'>
                  {item.displayValue}
                </span>
                {item.synonym && (
                  <span className='ml-1 text-sm italic text-gray-700'>
                    {item.synonym}
                  </span>
                )}
              </button>
            </li>
          ))}
        </ul>
      </div>
      {isLoading && (
        <div className='absolute right-2 top-2'>
          <ActivityIndicator color='#111827' size={12} />
        </div>
      )}
    </div>
  )
}

SelectPreset.propTypes = { callback: PropTypes.func.isRequired }

export default SelectPreset
